import { Container, Row, Col } from 'react-bootstrap';
import header from '../assets/header-img.svg';
import linkedin from '../assets/linkedin.svg';
import github from '../assets/github.svg';
import medium from '../assets/medium.svg';
import wave from '../assets/wave.png';

const Banner = () => (
  <section className="banner" id="home">
    <Container>
      <Row className="align-items-center">
        <Col xs={12} md={6} xl={7}>
          <div className="banner-content">
            <h1>
              Hi there
              {' '}
              <img src={wave} alt="Wave" />
              {' '}
              <br />
              I&apos;m Thomas Obuya
            </h1>
            <h2>Web Developer & Data Scientist</h2>
            <p>
              I&apos;m a Full-stack Web Developer and Data Scientist with a passion for
              developing user-friendly web applications and extracting valuable insights
              from data. I bring expertise in both development and collaboration, having
              experience working with teams, tracking changes, and mentoring. Whether it&apos;s
              building robust backends, designing intuitive interfaces, or extracting valuable
              insights from data, I&apos;m passionate about creating solutions that empower
              businesses and users. Explore my projects to see how my skills can elevate
              your next project.
            </p>
            <div className="social-links social-icon">
              <a href="https://www.linkedin.com/in/tobuya/" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} alt="LinkedIn" />
              </a>
              <a href="https://github.com/tobuya" target="_blank" rel="noopener noreferrer">
                <img src={github} alt="GitHub" />
              </a>
              <a href="https://medium.com/@tobuya" target="_blank" rel="noopener noreferrer">
                <img src={medium} alt="Medium" />
              </a>
            </div>
          </div>
        </Col>
        <Col xs={8} md={6} xl={5}>
          <img src={header} alt="Header" />
        </Col>
      </Row>
    </Container>
  </section>
);

export default Banner;
